import Modulos from '@/classes/enums/Modulos'

export default [
  {
    path: 'trash',
    name: 'trash',
    redirect: { name: 'trash/invoicesissued' }
  },
  {
    path: 'trash',
    name: 'trashad',
    redirect: { name: 'trash/companies' }
  },
  {
    path: 'trash/invoicesissued',
    name: 'trash/invoicesissued',
    component: () => import('@/views/trash/InvoicesIssued.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.EMISION_FACTURAS]] }
  },
  {
    path: 'trash/invoicesissued/:idFacturae/:idInvoice/details',
    name: 'trash/invoicesissued/details',
    component: () => import('@/views/trash/Invoice.vue'),
    meta: { secondaryMenu: 'configurations/trash/invoicesissued', registerNavFromMenu: false, recibida: false, modules: [[Modulos.EMISION_FACTURAS]] }
  },
  {
    path: 'trash/invoicesissued/:idFacturae/:idInvoice/historical',
    name: 'trash/invoicesissued/historical',
    component: () => import('@/views/historical/TrashInvoiceHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/invoicesissued', registerNavFromMenu: false, recibida: false, modules: [[Modulos.EMISION_FACTURAS]] }
  },
  {
    path: 'trash/invoicesreceived',
    name: 'trash/invoicesreceived',
    component: () => import('@/views/trash/InvoicesReceived.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.RECEPCION_FACTURAS]] }
  },
  {
    path: 'trash/invoicesreceived/:idFacturae/:idInvoice/details',
    name: 'trash/invoicesreceived/details',
    component: () => import('@/views/trash/Invoice.vue'),
    meta: { secondaryMenu: 'configurations/trash/invoicesreceived', registerNavFromMenu: false, recibida: true, modules: [[Modulos.RECEPCION_FACTURAS]] }
  },
  {
    path: 'trash/invoicesreceived/:idFacturae/:idInvoice/historical',
    name: 'trash/invoicesreceived/historical',
    component: () => import('@/views/historical/TrashInvoiceHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/invoicesreceived', registerNavFromMenu: false, recibida: true, modules: [[Modulos.RECEPCION_FACTURAS]] }
  },
  {
    path: 'trash/companies',
    name: 'trash/companies',
    component: () => import('@/views/trash/Companies.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'trash/companies/:id/details',
    name: 'trash/companies/details',
    component: () => import('@/views/trash/Company.vue'),
    meta: { secondaryMenu: 'configurations/trash/companies', registerNavFromMenu: false }
  },
  {
    path: 'trash/companies/:id/historical',
    name: 'trash/companies/historical',
    component: () => import('@/views/historical/TrashCompanyHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/companies', registerNavFromMenu: false }
  },
  {
    path: 'trash/certificates',
    name: 'trash/certificates',
    component: () => import('@/views/trash/Certificates.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'trash/certificates/:idCliente/:SerialNumber/:TipoCertificado/details',
    name: 'trash/certificates/details',
    component: () => import('@/views/trash/Certificate.vue'),
    meta: { secondaryMenu: 'configurations/trash/certificates', registerNavFromMenu: false }
  },
  {
    path: 'trash/certificates/:idCliente/:SerialNumber/:TipoCertificado/historical',
    name: 'trash/certificates/historical',
    component: () => import('@/views/historical/TrashCertificateHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/certificates', registerNavFromMenu: false }
  },
  {
    path: 'trash/users',
    name: 'trash/users',
    component: () => import('@/views/trash/Users.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'trash/users/:id/details',
    name: 'trash/users/details',
    component: () => import('@/views/trash/User.vue'),
    meta: { secondaryMenu: 'configurations/trash/users', registerNavFromMenu: false }
  },
  {
    path: 'trash/users/:id/historical',
    name: 'trash/users/historical',
    component: () => import('@/views/historical/TrashUserHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/users', registerNavFromMenu: false }
  },
  {
    path: 'trash/groups',
    name: 'trash/groups',
    component: () => import('@/views/trash/Groups.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'trash/groups/:id/details',
    name: 'trash/groups/details',
    component: () => import('@/views/trash/Group.vue'),
    meta: { secondaryMenu: 'configurations/trash/groups', registerNavFromMenu: false }
  },
  {
    path: 'trash/groups/:id/historical',
    name: 'trash/groups/historical',
    component: () => import('@/views/historical/TrashGroupHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/groups', registerNavFromMenu: false }
  },
]
